import type { Entry, EntryFieldTypes, EntrySkeletonType, UnresolvedLink } from 'contentful';
import type { InternalPage } from 'libs/contentful/types';

export interface InternalPageFields {
  slug: EntryFieldTypes.Symbol;
}

export type InternalPageContentTypeId =
  'page' | 'paidPage' | 'pageBlogPostFlexible' | 'pageAgreement' | 'pageCareersTemplate';

export type InternalPageSkeleton = EntrySkeletonType<InternalPageFields, InternalPageContentTypeId>;

/** Contentful can leave archived targets as raw Links despite `WITHOUT_UNRESOLVABLE_LINKS`. */
export function toInternalPage(
  page: Entry<InternalPageSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'> | UnresolvedLink<'Entry'> | undefined,
): InternalPage | undefined {
  if (page == null || !('fields' in page)) return undefined;

  const { fields, sys } = page;
  if (typeof fields.slug !== 'string') return undefined;

  return {
    sys: { id: sys.id },
    slug: fields.slug,
  };
}
